<div class="wrapper">
    <section class="main">
        <h1>Your Recent Decks</h1>
        <app-pretty-deck-list [decks]="decks | async" (deleteClicked)="deleteDeck($event)"></app-pretty-deck-list>

        <h1>Your Recent Additions</h1>
        <app-pretty-card-list [cards]="cards"></app-pretty-card-list>

        <h1>Popular Decks</h1>
        <app-pretty-deck-list [decks]="publicDecks | async" [isPublicView]="true"></app-pretty-deck-list>

        <h1>Popular Legendary Creatures</h1>
        <app-pretty-card-list [cards]="popularCreatures | async"></app-pretty-card-list>

        <h1>Popular Artifacts</h1>
        <app-pretty-card-list [cards]="popularArtifacts | async"></app-pretty-card-list>

        <h1>Popular Commanders</h1>
        <app-pretty-card-list [cards]="popularCommanders | async"></app-pretty-card-list>

        <h1>Top {{numberOfEdhrecRankedCards}} on EDHREC</h1>
        <app-pretty-card-list [cards]="edhrecRankedCards | async"></app-pretty-card-list>
    </section>
    <section class="magic-news">
        <h1>Magic Feed</h1>
        <div class="magic-news-wrapper">
            <mat-card class="news-item mat-elevation-z4" *ngFor="let item of newsItems">
                <mat-card-header>
                    <mat-card-title>{{item.title}}</mat-card-title>
                    <mat-card-subtitle [innerText]="item['dc:creator']"></mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div [innerHTML]="item.description"></div>
                </mat-card-content>
                <em [style.font-size]="'80%'">{{item.pubDateString}}</em>
            </mat-card>
        </div>
    </section>
</div>
